var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "c0dd7b04cc30c0cc70bd7eb3b73a82c1ed456ca8"
};